module.exports = __webpack_public_path__ + "img/Pattern05.f4399199.png";